/**
 * @generated SignedSource<<dc15b726aabfbde534484a74bfbc4d74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeaturedContentBlock_block",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeaturedContentBlockText_block"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeaturedContentBlockImage_block"
    }
  ],
  "type": "FeaturedContentBlock",
  "abstractKey": null
};

node.hash = "b89eb11d489045c89b1421d256f9c8f1";

module.exports = node;
